import { create } from "zustand";
import { persist } from "zustand/middleware";

export const DOCK_SHORTCUT_SLOT_COUNT = 9;

export function normalizeDockSlots(slots) {
  const normalized = Array(DOCK_SHORTCUT_SLOT_COUNT).fill(null);
  const seen = new Set();

  if (!Array.isArray(slots)) return normalized;

  slots.slice(0, DOCK_SHORTCUT_SLOT_COUNT).forEach((value, index) => {
    if (typeof value !== "string" || !value || seen.has(value)) return;
    normalized[index] = value;
    seen.add(value);
  });

  return normalized;
}

export function resolveDockPreferences(preferences) {
  return {
    enabled: preferences?.enabled !== false,
    expanded: preferences?.expanded !== false,
    slots: normalizeDockSlots(preferences?.slots),
  };
}

export function getDockPreferenceKey(user, tenantId) {
  const rawUserId = user?._id?.$oid || user?._id || user?.id || user?.userId;
  if (!rawUserId || !tenantId) return null;
  return `${String(rawUserId)}:${String(tenantId)}`;
}

export const useDockPreferencesStore = create(
  persist(
    (set) => ({
      preferencesByScope: {},
      setPreferences: (scopeKey, preferences) => {
        if (!scopeKey) return;
        set((state) => ({
          preferencesByScope: {
            ...state.preferencesByScope,
            [scopeKey]: resolveDockPreferences(preferences),
          },
        }));
      },
      setExpanded: (scopeKey, expanded) => {
        if (!scopeKey) return;
        set((state) => ({
          preferencesByScope: {
            ...state.preferencesByScope,
            [scopeKey]: {
              ...resolveDockPreferences(state.preferencesByScope[scopeKey]),
              expanded: Boolean(expanded),
            },
          },
        }));
      },
    }),
    { name: "dock-preferences-storage" },
  ),
);
